/**
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { Component } from 'react';
import Float from 'components/UI/Float';
import './TransactionSearchFloat.scss';
import locale from './locale'

class TransactionSearchFloat extends Component {

  constructor(props) {
    super(props);

    this.state = {
      number: ''
    }

    this.renderFloatContent = this.renderFloatContent.bind(this);
  }

  renderFloatContent() {
    const { onSubmitSearch } = this.props;
    const { number } = this.state;

    return (
      <div className='TransctionSearch-float container-fluid text-center'>
        <div className='TransctionSearchHeader'>{__('Electronic Receipt No.', locale)}</div>
        <input className='form-control TransctionSearchInput' value={number} onChange={(e) => {
          this.setState({number: e.target.value})
        }} />
        <button className='btn btn-primary TransctionSearchBtn' onClick={() => {onSubmitSearch(number)}} disabled={number.length<1}>{__('Search', locale)}</button>
      </div>
    );
  }

  render() {
    let {
      show,
      target,
      onCloseFloat,
      container,
    } = this.props;

    return (
      <Float
        container={container}
        show={show}
        target={target}
        floatWidth={250}
        onCloseFloat={()=>{
          this.setState({number: ''});
          onCloseFloat();
        }}
      >
        {this.renderFloatContent()}
      </Float>
    )
  }
}

export default TransactionSearchFloat;



// WEBPACK FOOTER //
// ./src/template/Floats/TransactionSearchFloat/index.js